import React from "react";
import SetaCard from "../../img/arrow-right-line.svg"

/*
🔹 Componente Card
Responsável por exibir um projeto em formato resumido
usado em carrosséis e listas.

Agora suporta:
• vídeo local
• imagem
• YouTube
• SVG
*/

function Card({ projeto, onClick }) {

  /* 🔹 Estrutura de mídia definida no JSON */
  const { apresentacao } = projeto;

  return (
    <div className="card" onClick={function () { onClick(projeto.id); }}>

      {/* ========================= MÍDIA ========================= */}
      <div className="card-media">

        {/* 🔹 Vídeo local */}
        {apresentacao.tipo === "video" && (
          <video
            src={apresentacao.arquivo}
            controls
            className="card-video"
          />
        )}

        {/* 🔹 Imagem comum */}
        {apresentacao.tipo === "imagem" && (
          <img
            src={apresentacao.arquivo}
            alt={projeto.titulo}
            className="card-image"
          />
        )}

        {/* 🔹 SVG */}
        {apresentacao.tipo === "svg" && (
          <img
            src={apresentacao.arquivo}
            alt={projeto.titulo}
            className="card-image"
          />
        )}

        {/* 🔹 YouTube */}
        {apresentacao.tipo === "youtube" && (
          <iframe
            src={apresentacao.url}
            title={projeto.titulo}
            className="card-video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        )}

      </div>

      {/* ========================= CONTEÚDO ========================= */}
      <div className="card-content">

        <div className="card-tags">
          {projeto.tags.map(function (tag, index) {
            return (
              <span className="card-tag" key={index}>
                {tag + " "}
              </span>
            );
          })}
        </div>

        <h3 className="card-title">{projeto.titulo}</h3>

        <p className="card-description">{projeto.descricao}</p>
        <div className="card-acao">
          <img
            src={SetaCard}
            alt="ver projeto"
            className="card-seta"
          />
        </div>

      </div>
    </div>
  );
}

export default Card;